/**
 * Product Families Actions
 */

import { ProductFamily } from '../../common/models/product-family.model';
import {
  SET_PRODUCT_FAMILIES,
  SET_PRODUCT_FAMILIES_LOADING,
  SET_PRODUCT_FAMILIES_ERROR,
  SET_ACTIVE_FAMILY,
  ADD_PRODUCT_FAMILY,
  UPDATE_PRODUCT_FAMILY,
  DELETE_PRODUCT_FAMILY,
  SET_SELECTED_FAMILY_FILTER,
} from './productFamiliesActionTypes';

/**
 * Set the list of product families
 */
export const setProductFamilies = (families: ProductFamily[]) => ({
  type: SET_PRODUCT_FAMILIES,
  payload: families,
});

/**
 * Set loading state
 */
export const setProductFamiliesLoading = (loading: boolean) => ({
  type: SET_PRODUCT_FAMILIES_LOADING,
  payload: loading,
});

/**
 * Set error state
 */
export const setProductFamiliesError = (error: string | null) => ({
  type: SET_PRODUCT_FAMILIES_ERROR,
  payload: error,
});

/**
 * Set the currently active/selected family (for editing)
 */
export const setActiveFamily = (family: ProductFamily | null) => ({
  type: SET_ACTIVE_FAMILY,
  payload: family,
});

/**
 * Add a new product family to the list
 */
export const addProductFamily = (family: ProductFamily) => ({
  type: ADD_PRODUCT_FAMILY,
  payload: family,
});

/**
 * Update an existing product family in the list
 */
export const updateProductFamily = (family: ProductFamily) => ({
  type: UPDATE_PRODUCT_FAMILY,
  payload: family,
});

/**
 * Remove a product family from the list
 */
export const deleteProductFamily = (familyId: string) => ({
  type: DELETE_PRODUCT_FAMILY,
  payload: familyId,
});

/**
 * Set the family filter for product listing
 */
export const setSelectedFamilyFilter = (familyId: string | null) => ({
  type: SET_SELECTED_FAMILY_FILTER,
  payload: familyId,
});
